
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 11.738c2.668 0 4.832-2.628 4.832-5.87C16.832 2.629 16.122 0 12 0S7.168 2.628 7.168 5.869c0 3.241 2.163 5.869 4.832 5.869zM2.874 20.699c-.001-.198-.002-.056 0 0zM21.126 20.853c.002-.054 0-.376 0 0z","fill":"#838383"}}),_c('path',{attrs:{"d":"M21.116 20.462c-.09-5.647-.827-7.256-6.47-8.274 0 0-.795 1.012-2.646 1.012s-2.646-1.012-2.646-1.012c-5.581 1.007-6.364 2.592-6.466 8.09-.009.45-.013.473-.014.42v.594S4.218 24 12 24c7.782 0 9.125-2.708 9.125-2.708v-.439c0 .032-.004-.03-.01-.391z","fill":"#838383"}})])
          )
        }
      }
    